import React from 'react';

import { DEFAULT_STATE } from '../constants';

export const HtmlElementPageContext = React.createContext(DEFAULT_STATE);
export const HtmlElementPageProvider = HtmlElementPageContext.Provider;
